<template>
    <div id="accommodation-consideration">
        <v-card-title>
            <v-icon :color="kingsGold" left>mdi-hand-heart</v-icon> Accommodation Consideration(s) (Optional)
        </v-card-title>
        <v-card-subtitle>
            To determine how we can best meet your special accommodation needs, it is helpful to
            understand your particular needs. Please provide additional information in the areas below
            if you have special accommodation needs.
        </v-card-subtitle>
        <v-card-text >
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <v-textarea v-model="item.specialAccommodationConsideration" auto-grow
                            hint="For instance, is a main floor room for accessibility reasons, a room close to a washroom for medical reasons, a quieter area for sleep issues, or a single room for a particular reason. Please provide any information you believe to be relevant to your request."
                            label="What type of accommodation consideration are you requesting and what needs motivate this request? (Optional)"
                            persistent-hint placeholder="None" readonly outlined>
                        </v-textarea>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="item.specialAccommodationBasis"
                            label="Is your request based on a significant impairment, medical condition, physical or personal challenge? (Optional)"
                            placeholder="None" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea v-model="item.specialAccommodationDescription" auto-grow
                            label="Please describe the current impact and/or limitations imposed by your condition or challenge (Optional)"
                            persistent-hint placeholder="None" readonly outlined>
                        </v-textarea>
                    </v-col>
                    <v-col cols="12" v-if="showSuperSingleRequestView == false">
                        <v-text-field v-model="item.singleRoomRequestReason" readonly
                            label="Single Room Request Reason" placeholder="Not specified">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="showSuperSingleRequestView == true && showSingleRoomRequest() == true">
                        <v-checkbox v-model="item.requestSuperSingle" hide-details true-value="yes" false-value="no" label="I am requesting a Super Single" readonly></v-checkbox>
                    </v-col>
                    <v-col cols="12" v-if="showSuperSingleRequestView == true && showSingleRoomRequest() == true">
                        <v-checkbox v-model="item.requestSingleRoom" true-value="yes" false-value="no" label="I am requesting a Single Room" readonly></v-checkbox>
                    </v-col>
                    <v-col cols="12"> </v-col>
                    <v-col cols="12">
                        <v-textarea v-model="item.singleRoomRequestAdditionalInformation" auto-grow readonly hide-details
                            label="Special Room Request Additional Information" outlined placeholder="Not specified">
                        </v-textarea>
                    </v-col>
                </v-row>
                <v-card-subtitle class="px-0 pb-0">
                    <v-icon :color="kingsGold" left>mdi-signature</v-icon><b>Special Accommodations Terms</b>
                    <br>
                    I understand the Residence Office may, in confidence, share this information to consult with
                    Accessibility Services and /or Student Health Services to fully assess this
                    request. I give the Residence Office permission to do this. I give the Residence Office
                    permission to confirm with Accessibility Services that I have contacted
                    that office to arrange support services for the academic year.
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12">
                        <v-checkbox v-model="item.specialAccommodationAgreeToTerms" false-value="0"
                            label="I have read and agree to the Special Accommodations Terms" readonly true-value="1">
                        </v-checkbox>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
export default {
    name: 'application-accommodation-consideration',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    data(){
        return {
            showSuperSingleRequestView: true
        }
    },
    computed: {
        kingsGold() {
            return '#d7ae28';
        }
    },
    methods: {
        checkSubmissionDate(){
            const that = this;

            let createdTimestamp = that.item.createdTimestamp;
            let cutoffDate = 0;

            //Update Nov 7, 2025
            //If submitted before Nov 14 00:00 AM (1763096401), show older Single Room request, else show the new Single Room / Super Single request view (production)
            
            if(location.hostname == 'mykings.ca'){
                cutoffDate = 1763096401; //2025 Nov 14 00:00:01
            }else {
                cutoffDate = 1762542000; //2025 Nov 07 14:00:00
            }

            if(parseInt(createdTimestamp) < parseInt(cutoffDate)){
                that.showSuperSingleRequestView = false;
            }else {
                that.showSuperSingleRequestView = true;
            }
            
        },
        showSingleRoomRequest(){

            let buildingOption1Check = /Epworth Place/i.test(this.item.buildingOption01) || /King's Commons/i.test(this.item.buildingOption01);
            let buildingOption2Check = /Epworth Place/i.test(this.item.buildingOption02) || /King's Commons/i.test(this.item.buildingOption02);
            let upperyear = ["2", "3", "4"]
            let yearofStudyCheck = upperyear.includes(this.item.yearOfStudy)

            if(yearofStudyCheck && (buildingOption1Check || buildingOption2Check)){
                return false
            }

            return true

        } 
    },
    beforeUpdate(){
        this.checkSubmissionDate();
    }
}
</script>

<style scoped>
.v-card__subtitle {
    font-weight: bold;
}
</style>